import React, { useState } from 'react'
import Header from '../../header/Header';
import Sidebarr from '../../sidebar/Sidebar';
import VendorSidebar from '../../sidebar/VendorSidebar';
import Footer from '../../footer/Footer';
import SyncGif from "./loader.gif";
import SuccessGif from "./success.gif";
import axios from "axios";
import { useSelector } from "react-redux";

export default function DescriptionSync() {
  const auth = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [lastRun, setLastRun] = useState(null);






  const syncStock = async () => {
    setError(null);
    setSuccess(false);
    setLoading(true);

    try {
      const token = auth?.user?.token || auth?.token || '';
      const config = {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
          'Content-Type': 'application/json',
        },
      };

      const data = {}
      await axios.post(process.env.REACT_APP_BASE_URL + '/cron/start/manually', data);

      setLastRun(new Date().toISOString());
      setSuccess(true);
    } catch (err) {
      console.error('Sync failed', err?.response || err.message || err);
      const message = err?.response?.data?.message || err?.message || 'Sync failed';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sidebar-mini skin-green-light">
      <div className="wrapper">
        <Header />
        {auth?.user?.role === 'Vendor' ? <VendorSidebar /> : <Sidebarr />}

        <div className="content-wrapper">
          <section className="content-header">
            <h1>Sync ERP</h1>
            <ol className="breadcrumb">
              <li>
                <a href="#">
                  <i className="fa fa-dashboard" /> Home
                </a>
              </li>
            </ol>
          </section>

          <section className="content">
            <div className="box">
              <div className="box-body">
                <div className="flex flex-col items-center justify-center text-center min-h-screen bg-gradient-to-br from-gray-100 via-white to-gray-200 px-[10%] py-8">

                  {/* Button */}
                  <button
                    onClick={syncStock}
                    disabled={loading}
                    className={
                      `px-10 py-4 text-lg font-semibold text-white rounded-2xl shadow-xl transform transition duration-300 ease-in-out focus:outline-none focus:ring-4 focus:ring-pink-300 text-[18px] ` +
                      (loading ? 'opacity-70 cursor-not-allowed bg-gray-400' : 'bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 hover:scale-105 hover:shadow-2xl')
                    }
                  >
                    {loading ? (
                      <span className="flex items-center gap-2 justify-center">
                        <img src={SyncGif} alt="loading" className="w-6 h-6" />
                        Syncing...
                      </span>
                    ) : (
                      '🔄 Sync Product'
                    )}
                  </button>

                  {/* Result UI */}
                  <div className="mt-4 text-center">
                    {success && (
                      <div className="flex items-center gap-1 justify-center">
                        <img src={SuccessGif} alt="success" className="w-8 h-8" />
                        <span className="font-medium text-green-700" style={{ fontSize: "16px" }}>Sync request executed successfully. Please wait sometime to reflect changes.</span>
                      </div>
                    )}


                  </div>
                </div>



              </div>
            </div>
          </section>
        </div>
        <Footer />
        <div className="control-sidebar-bg" />
      </div>
    </div>
  );
}
